import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SignaturePadModule } from 'angular2-signaturepad';

import { IonicModule } from '@ionic/angular';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { IonicSelectableModule } from 'ionic-selectable';

import { TranslateModule } from '@ngx-translate/core';

import { ComponentsLibModule } from '@arpada/arp-shared-comp-qupro';

import { PipesModule } from '../../pipes/pipes.module';

import { UiService } from '../../services/api.services';

import { ProformaStateChipComponent } from './proforma-state-chip/proforma-state-chip.component';
import { BoolAsIconComponent } from './bool-as-icon/bool-as-icon.component';
import { IssueStategroupChipComponent } from './issue-stategroup-chip/issue-stategroup-chip.component';
import { IssuePriorityChipComponent } from './issue-priority-chip/issue-priority-chip.component';
import { ActionsHeaderComponent } from './actions-header/actions-header.component';
import { MoreActionsIssuesComponent } from './actions-header/more-actions-issues/more-actions-issues.component';
import { FilterIssuesComponent } from './actions-header/filter-issues/filter-issues.component';
import { OrderIssuesComponent } from './actions-header/order-issues/order-issues.component';
import { PortalModalComponent } from './portal-modal/portal-modal.component';
import { FilterProformaComponent } from './actions-header/filter-proforma/filter-proforma.component';
import { OperarioChipComponent } from './operario/operario-chip/operario-chip.component';
import { AsignarOperarioComponent } from './operario/asignar-operario/asignar-operario.component';
import { SelectorOperarioComponent } from './operario/selector-operario/selector-operario.component';
import { DescargaHojasTrabajoComponent } from './descarga-hojas-trabajo/descarga-hojas-trabajo.component';
import { FilterIssuesProformablesComponent } from './actions-header/filter-issues-proformables/filter-issues-proformables.component';
import { ElipsisModalComponent } from './elipsis-modal/elipsis-modal.component';
import { AddComentarioModalComponent } from './add-comentario-modal/add-comentario-modal.component';
import { SignatureWidgetComponent } from './signature-widget/signature-widget.component';
import { EdicionMasivaComponent } from './edicion-masiva/edicion-masiva.component';
import { IssuesInfoComponent } from './edicion-masiva/issues-info/issues-info.component';
import { IssuesErrorComponent } from './edicion-masiva/issues-error/issues-error.component';
import { IssueImageComponent } from './issue-image/issue-image.component';
import { FaltaMaterialComponent } from './falta-material/falta-material.component';
import { EditarIssueEscritorioComponent } from './editar-issue-escritorio/editar-issue-escritorio.component';
import { EditarIssueComponent } from './editar-issue/editar-issue.component';
import { ContactDataComponent } from './contact-data/contact-data.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FilterConformeComponent } from './actions-header/filter-conforme/filter-conforme.component';


@NgModule({
  declarations: [
    BoolAsIconComponent,
    IssuePriorityChipComponent,
    IssueStategroupChipComponent,
    OperarioChipComponent,
    ProformaStateChipComponent,
    ActionsHeaderComponent,
    MoreActionsIssuesComponent,
    FilterIssuesComponent,
    OrderIssuesComponent,
    AsignarOperarioComponent,
    PortalModalComponent,
    FilterProformaComponent,
    SelectorOperarioComponent,
    DescargaHojasTrabajoComponent,
    FilterIssuesProformablesComponent,
    ElipsisModalComponent,
    AddComentarioModalComponent,
    SignatureWidgetComponent,
    EdicionMasivaComponent,
    IssuesInfoComponent,
    IssuesErrorComponent,
    IssueImageComponent,
    FaltaMaterialComponent,
    EditarIssueEscritorioComponent,
    EditarIssueComponent,
    ContactDataComponent,
    FilterConformeComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule,
    IonicSelectableModule,
    TranslateModule,
    ComponentsLibModule,
    SignaturePadModule,
    NgxDatatableModule,
  ],
  exports: [
    BoolAsIconComponent,
    IssuePriorityChipComponent,
    IssueStategroupChipComponent,
    OperarioChipComponent,
    ProformaStateChipComponent,
    ActionsHeaderComponent,
    MoreActionsIssuesComponent,
    FilterIssuesComponent,
    OrderIssuesComponent,
    AsignarOperarioComponent,
    PortalModalComponent,
    FilterProformaComponent,
    SelectorOperarioComponent,
    DescargaHojasTrabajoComponent,
    FilterIssuesProformablesComponent,
    ElipsisModalComponent,
    AddComentarioModalComponent,
    SignatureWidgetComponent,
    IssueImageComponent,
    FaltaMaterialComponent,
    EditarIssueEscritorioComponent,
    EditarIssueComponent,
    ContactDataComponent,
    FilterConformeComponent
  ],
  providers: [
    ScreenOrientation,
    { provide: 'LoginRedirectObservableEvent', useClass: UiService},
  ],
  entryComponents: [
    PortalModalComponent,
    FilterIssuesComponent,
    OrderIssuesComponent,
    FilterProformaComponent,
    DescargaHojasTrabajoComponent,
    FilterIssuesProformablesComponent,
    SignatureWidgetComponent,
    EdicionMasivaComponent,
    FilterConformeComponent
  ]
})
export class SharedModule { }
